import { render, staticRenderFns } from "./TextPageFooterSectionPopup.vue?vue&type=template&id=36013c78&"
import script from "./TextPageFooterSectionPopup.vue?vue&type=script&lang=js&"
export * from "./TextPageFooterSectionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports